import DebugImages from './DebugImages';

export default DebugImages;
